import { render, staticRenderFns } from "./SnackbarNotification.vue?vue&type=template&id=3b0df46e&"
import script from "./SnackbarNotification.vue?vue&type=script&lang=js&"
export * from "./SnackbarNotification.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarNotification.vue?vue&type=style&index=0&id=3b0df46e&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b0df46e')) {
      api.createRecord('3b0df46e', component.options)
    } else {
      api.reload('3b0df46e', component.options)
    }
    module.hot.accept("./SnackbarNotification.vue?vue&type=template&id=3b0df46e&", function () {
      api.rerender('3b0df46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/SnackbarNotification/SnackbarNotification.vue"
export default component.exports